  import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const K0 = (Math.floor(Math.random() * 10) + 1) * 1000; // 1000, 2000…
  const p = Math.floor(Math.random() * 8) + 5;            // 5–12%
  const n = Math.floor(Math.random() * 5) + 2;            // 2–6 lat

  const Kn = +(K0 * (1 + n * p / 100)).toFixed(2);

  return {
    type: "FindFinalAmountSimpleInterestTask",
    data: { K0, p, n, Kn }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { K0, p, n } = data;

  return (
    <>
      <p>
        Kapitał początkowy <InlineMath math={`K_0 = ${K0}`} /> zł
        został ulokowany na lokacie z rocznym oprocentowaniem{" "}
        <InlineMath math={`${p}\\%`} /> na okres{" "}
        <InlineMath math={`${n}`} /> lat. Odsetki nie są kapitalizowane
        (procent prosty).
      </p>
      <p>
        Oblicz kapitał końcowy <InlineMath math={`K`} />.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="K"
      suffixLatex="\text{zł}"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseFloat(userAnswer.raw);
  if (isNaN(given)) return false;

  return Math.abs(given - data.Kn) < 0.01;
}

export function renderAnswer({ data }) {
  const { Kn } = data;

  const isApprox = !(Number.isInteger(Kn) || Kn === parseFloat(Kn.toFixed(0)));
  const symbol = isApprox ? '\\approx' : '=';

  return (
    <InlineMath math={`K ${symbol} ${Kn} \\, \\text{zł}`} />
  );
}

export function renderExplanation({ data }) {
  const { K0, p, n, Kn } = data;

  const multiplier = 1 + (n * p) / 100;

  const isKnApprox =
    Math.abs(Kn - Math.round(Kn)) > 1e-2 &&
    Math.abs(Kn - parseFloat(Kn.toFixed(0))) > 1e-2;

  const knSymbol = isKnApprox ? '\\approx' : '=';

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Wzór na kapitał końcowy przy procentach prostych:
      </p>
      <BlockMath math={`K = K_0 \\cdot \\left(1 + n \\cdot \\frac{p}{100}\\right)`} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane:
      </p>
      <BlockMath
        math={`K = ${K0} \\cdot \\left(1 + ${n} \\cdot \\frac{${p}}{100}\\right)`}
      />
      <BlockMath
        math={`K = ${K0} \\cdot ${multiplier.toFixed(3)}`}
      />
      <BlockMath
        math={`K ${knSymbol} ${Kn} \\, \\text{zł}`}
      />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`K = ${userAnswer.raw} \\, \\text{zł}`}/>;
}
